import { motion } from 'framer-motion'
const Hero = ({setCursorVariant}) => {
  
  return (
    <div className="container project"  >
            
      <motion.main className='main' initial={{ overflow: 'hidden' }}>
        {/* <motion.div className='image' initial={{ x: '-100vw', opacity: 0 }} animate={{ x: 0, opacity: 1 }} transition={{ duration: 0.5, damping: 1 }}>
          <img src={require("../images/5098-removebg-preview.webp")} alt="me" className='img-fluid' />
        </motion.div> */}
        <div className="opaque"></div>
        <motion.div className='par' initial={{ x: '100vw', opacity: 0 }} animate={{ x: 0, opacity: 1 }} transition={{ type: "spring", duration: 0.5, damping: 20, stiffness: 400, }} >
          I'm  
          <span> Abdelrahman </span>
           Adel.
          a Full Stack web developer 'MERN'
          based in egypt.
          
          
        </motion.div>
      </motion.main>
    </div>
  );
}

export default Hero
